import Http from "./Http";

export default {

async getCategories(){
    return await Http.get(`/merchandise/categories`);
},
async createCategory(data){
    return await Http.post(`/merchandise/categories`, data);
},
async getTags(){
    return await Http.get(`/merchandise/tags`);
},
async getProducts(params = '') {
    return await Http.get(`/merchandise/products?${params}`)
},
async getStatistics(params = '') {
    return await Http.get(`/merchandise/products/statistics?${params}`)
},
async getProduct(product_id) {
    return await Http.get(`/merchandise/products/${product_id}`)
},
async getProductRelated(product_id) {
    return await Http.get(`/merchandise/product/related/${product_id}`)
},
async addRelatedProduct(product_id,rel_slug) {
    return await Http.post(`/merchandise/product/related/${product_id}`, {
        rel_slug: rel_slug
    });
},
async removeRelated(product_id,rel_slug){
    return await Http.delete(`/merchandise/product/related/${product_id}`, {
       data: { rel_slug: rel_slug }
    });
},
async getTagsByProduct(product_id) {
    return await Http.get(`/merchandise/products/${product_id}/tags`)
},
async attachTag(product_id, tag_id) {
    return await Http.post(`/merchandise/product/${product_id}/tag/attach`, {
      tag_id: tag_id,
    });
  },
async detachTag(product_id, tag_id) {
    return await Http.post(`/merchandise/product/${product_id}/tag/detach`, {
      tag_id: tag_id,
    });
  },
async getMedia(params = '') {
    return await Http.get(`/merchandise/media`)
},
async updateMedia(data) {
    return await Http.post(`/merchandise/media`, data, {
        headers: {
            'Content-Type':'multipart/form-data'
        }
    })
},async createMedia(data) {
        return await Http.post(`/merchandise/media`, data, {
            headers: {
                'Content-Type':'multipart/form-data'
            }
        })
    },

    async deleteMedia(position) {
        return await Http.delete(`/merchandise/media/${position}` , position)
    },

    async getMediaPosition(){
        return await Http.get(`/merchandise/media/position`)
    },

async getPromotions(params = '') {
    return await Http.get(`/merchandise/product/promo?${params}`)
},
async getBestSeller(params = '') {
    return await Http.get(`/merchandise/product/bestseller?${params}`)
},
async removePromotion(id) {
    return await Http.delete(`/merchandise/product/promo?product_id=${id}`)
},
async removeBestSeller(id) {
    return await Http.delete(`/merchandise/product/bestseller?product_id=${id}`)
},
async getProductsAutocomplete(params = '') {
    return await Http.get(`/merchandise/products/autocomplete?${params}`)
},
async addPromotion(id) {
    return await Http.post(`/merchandise/product/promo?product_id=${id}`)
},
async addBestSeller(id) {
    return await Http.post(`/merchandise/product/bestseller?product_id=${id}`)
},
async updateCategorySlug(id,category_slug){
    return await Http.patch(`/merchandise/category/slug`,{
        id:id,
        category_slug:category_slug
    })
},
async updateCategoryOrder(id,order){
    return await Http.post(`/merchandise/category/order/new`,{
        id:id,
        order:order
    })
},
async updateCategoryVisibility(id,visibility){
    return await Http.post("/merchandise/category/visible/new",{
        id:id,
        visibility:visibility
    })
},
    async addBrand(data) {
        return await Http.post(`/merchandise/brands`, data)
    },
    async getMerchandiseBrand(params = '') {
        return await Http.get(`/merchandise/brands?${params}`)
    },
    async removeBrand(id) {
        return await Http.delete(`/merchandise/brands/${id}`)
    },
    async editMerchandiseBrand(data) {
        return await Http.post(`/merchandise/brand`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    async uploadCategoryMedia(data) {
        return await Http.post(`/merchandise/category/media`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    
    async uploadProductImage(data) {
        return await Http.post(`/merchandise/product/upload-image`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    async setMainProductImage(data) {
        return await Http.post(`/merchandise/product/set-main-image`, data);
    },

    async deleteProductImage(data) {
        return await Http.delete(`/merchandise/product/delete-image`, { data });
    },
    async getAttributes() {
        return await Http.get(`/merchandise/attributes`)
    },
    async getAttributeById(id) {
        return await Http.get(`/merchandise/attributes?attr_id=${id}`)
    },
    async addAttribute(data) {
        return await Http.post(`/merchandise/attributes`, data)
    },
    async updateAttribute(data) {
        return await Http.post(`/merchandise/attributes`, data)
    },
    async removeAttribute(attr_id) {
        return await Http.delete(`/merchandise/attributes?attr_id=${attr_id}`)
    },
    async linkAttributeToCategories(data) {
        return await Http.post(`/merchandise/attributes/linkToCategory`, data)
    },
    async unlinkCategoryFromAttribute(data) {
        return await Http.delete(`/merchandise/attributes/unlinkCategories${data}`, )
    },
    async getTerms(attr_id) {
        return await Http.get(`/merchandise/${attr_id}/terms`, )
    },
    async addBulkTerms(data) {
        return await Http.post(`/merchandise/bulk/terms`,data )
    },
    async addBulkProductsToTerm(data) {
        return await Http.post(`/merchandise/product/bulk/term`,data )
    },
    async updateTerm(data) {
        return await Http.post(`/merchandise/terms`,data )
    },
    async removeTerm(term_id) {
        return await Http.delete(`/merchandise/terms?term_id=${term_id}`)
    },
    async getProductTermsByTerm(term_id) {
        return await Http.get(`/merchandise/product/byTerm?term_id=${term_id}`)
    },
    async removeProductTerm(id){
        return await Http.delete(`/merchandise/product/term?id=${id}}`)
    },
    async getProductsByCategoryAttributes(category_ids) {
        return await Http.post(`/merchandise/products/categoryAttributes`,category_ids)
    },
    async getAttributeByCategoryId(category_id) {
        return await Http.get(`/merchandise/attributes?category_id=${category_id}`)
    },
    async getTermsForProduct(prod_id) {
        return await Http.get(`/merchandise/product/term?prod_id=${prod_id}`)
    },
    async addTermToProduct(data) {
        return await Http.post(`/merchandise/product/term`,data)
    },
    async getProductsMerch(params = '') {
         return await Http.get(`/merchandise/products/merch?${params}`)
    },
    async getProductMerch(product_id) {
        return await Http.get(`/merchandise/products/merch/${product_id}`)
    },
    async addRelatedProductMerch(product_id,rel_slug) {
        return await Http.post(`/merchandise/product/related/merch/${product_id}`, {
            rel_slug: rel_slug
        });
    },
    async getProductRelatedMerch(product_id) {
        return await Http.get(`/merchandise/product/related/merch/${product_id}`)
    },
    async getProductsAutocompleteMech(params = '') {
        return await Http.get(`/merchandise/products/autocomplete/merch?${params}`)
    },
    async getBestSellerMerch(params = '') {
        return await Http.get(`/merchandise/product/bestseller/merch?${params}`)
    },
    async getPromotionsMerch(params = '') {
        return await Http.get(`/merchandise/product/promo/merch?${params}`)
    },
    async addPromotionMerch(id) {
        return await Http.post(`/merchandise/product/promo/merch?product_id=${id}`)
    },
    async addBestSellerMerch(id) {
        return await Http.post(`/merchandise/product/bestseller/merch?product_id=${id}`)
    },
    async addTermToProductMerch(data) {
        return await Http.post(`/merchandise/product/term/merch`,data)
    },
    async attachTagMerch(product_id, tag_id) {
        return await Http.post(`/merchandise/product/${product_id}/tag/attach/merch`, {
            tag_id: tag_id,
        });
    },
    async getStatisticsMerch(params = '') {
        return await Http.get(`/merchandise/products/statistics/merch?${params}`)
    },
    async getProductTermsByTermMerch(term_id) {
        return await Http.get(`/merchandise/product/byTerm/merch?term_id=${term_id}`)
    },
    async getProductsByCategoryAttributesMerch(category_ids) {
        return await Http.post(`/merchandise/products/categoryAttributes/merch`,category_ids)
    },
    async uploadProductImageMerch(data) {
        return await Http.post(`/merchandise/product/upload-image/merch`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    async createProduct(data) {
        return await Http.post(`/merchandise/products/merch`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    async updateProduct(data) {
        return await Http.post(`/merchandise/products/merch`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    async changeProductStatus(data) {
        return await Http.post(`/merchandise/products/changeActiveStatus/merch`,data)
    },
    async getProductPriceTypes() {
        return await Http.get(`/merchandise/product/priceTypes/merch`)
    },
    async getMerchandiseCampaigns() {
        return await Http.get(`/merchandise/campaigns`)
    },
    async addMerchandiseCampaign(data) {
        return await Http.post(`/merchandise/campaigns`,data,{
            headers: { "Content-Type": "multipart/form-data" }
        })
    },
    async removeCampaign(campaign_guid) {
        return await Http.delete(`/merchandise/campaigns/${campaign_guid}`)
    },
    async updateMerchandiseCampaign(campaign_guid,data) {
        return await Http.post(`/merchandise/campaigns/${campaign_guid}`,data,{
            headers: { "Content-Type": "multipart/form-data" }
        })
    },
    async getCampaignProducts(campaign_guid) {
        return await Http.get(`/merchandise/campaigns/products/${campaign_guid}`)
    },
    async addCampaignProduct(data) {
        return await Http.post(`/merchandise/campaigns/products`,data)
    },
    async removeCampaignProduct(product_id,campaign_guid) {
        return await Http.delete(`/merchandise/campaigns/${campaign_guid}/products/${product_id}`)
    },
    async removeAllCampaignProduct(campaign_guid) {
        return await Http.delete(`/merchandise/campaigns/products/all/${campaign_guid}`)
    }
};